import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-927f9694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-content" }
const _hoisted_2 = { class: "update" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "场景存放路径：" + _toDisplayString($setup.buildModelPath), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" <a-button type=\"ghost\" size=\"large\" @click=\"selectDir\">更改路径</a-button> "),
      _createVNode(_component_a_button, {
        type: "ghost",
        size: "large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.useSend('openDir', $setup.sceneLocal)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("打开文件夹")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}